import script from "./SyndicationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SyndicationPanel.vue?vue&type=script&setup=true&lang=js"

import "./SyndicationPanel.vue?vue&type=style&index=0&id=520618aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520618aa"]])

export default __exports__